<template>
    <v-app theme="light" class="h-100 w-100" style="overflow: auto;">
        <div class="h-100 w-100" :style="`background-image:url(${background});`"  style="background-size: cover">
            <v-container style="padding-top: 100px;" class="h-100 w-100">
                <v-row no-gutters>
                    <v-col cols="12" sm="6" class="center">
                        <div style="font-size: 1.5rem;">
                            <div style="font-size: 3.5rem;">{{ $tr('Облачное хранилище') }}</div>
                            <b style="display: block; color:green; font-size: 2.8rem; ">ТОПОМАТИК</b>
                            <div>{{ $tr('Среда общих данных для проектов ROBUR') }}</div>
                        </div>
                        <v-btn @click="login">Войти</v-btn>
                    </v-col>
                    <v-col cols="12" sm="6" class="center">
                        <img :src="product" class="product" />
                    </v-col>
                </v-row>
                <v-row no-gutters style="padding-top: 100px; min-height: calc(55vh - 150px);" align="end">
                    <v-col cols="12" sm="4">
                        <v-card class="ma-2 pa-2">
                            <template v-slot:title>
                                {{ $tr('Проекты в облачном хранилище')}}
                            </template>
                            <template v-slot:text>
                                {{ $tr('В любой из программ комплекса Топоматик Robur войдите в учетную запись и бесплатно получите') }}
                                <b>500 МБ</b>
                                {{ $tr('для Ваших проектов') }}
                            </template>
                        </v-card>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-card class="card ma-2 pa-2">
                            <template v-slot:title>
                                {{ $tr('Работайте совместно')}}
                            </template>
                            <template v-slot:text>
                                {{ $tr('Настройте общий доступ и пригласите коллег для коллективной работы над проектами') }}
                            </template>
                        </v-card>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-card class="card ma-2 pa-2">
                            <template v-slot:title>
                                {{ $tr('Просматривайте чертежи и модели')}}
                            </template>
                            <template v-slot:text>
                                {{ $tr('На компьютере, планшете или смартфоне просто щелкайте на файлах чертежей dwp для их просмотра непосредственно в браузере') }}
                            </template>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </v-app>
</template>

<script>
import storage_background_image from '../assets/img/background.svg';
import product from '../assets/img/product.svg';

export default {
    name: 'SplashView',
    computed: {
        background() {
            return storage_background_image;
        },
        product() {
            return product;
        },
    },
    methods: {
        login() {
            this.$router.push({ view: 'login' });
        },
    },
};
</script>

<style scoped>
.product {
    width: 45vh;
    height: 45vh;
    max-width: 90vw;
    max-height: 90vw;
}
.center {
    align-self: center;
    text-align: center;
}
</style>
